(function () {
    'use strict';

    angular
        .module('app.score-detail')
        .component('sc3ScoreDetailHoleScores', {
            templateUrl: 'app/score-detail/score-detail-hole-scores/score-detail-hole-scores.component.html',
            controller: ScoreDetailHoleScoresComponent,
            bindings: { data: '<' }
        });

    // Got some help from here: http://code.fitness/post/2016/06/capture-mouse-events.html
    ScoreDetailHoleScoresComponent.$inject = ['$scope', '$element', '$timeout', 'fairwayHitType', 'holesPlayed'];
    function ScoreDetailHoleScoresComponent($scope, $element, $timeout, fairwayHitType, holesPlayed) {
        var ctrl = this,
            scrollbox = null,
            downX = null,
            span = document.createElement('span');

        // properties
        ctrl.frontScores = [];
        ctrl.backScores = [];
        ctrl.totals = [];

        // methods
        ctrl.$onInit = init;
        ctrl.getCellClass = getCellClass;
        ctrl.getFirClass = getFirClass;
        ctrl.hideScrollbar = hideScrollbar;
        ctrl.isBackVisible = isBackVisible;
        ctrl.isEighteenHoles = isEighteenHoles;
        ctrl.isFrontVisible = isFrontVisible;
        ctrl.isScrollStart = true;
        ctrl.isScrollEnd = false;
        ctrl.showFront = showFront;
        ctrl.showBack = showBack;

        //////////////////////////////////

        function init() {
            var holeScores = ctrl.data.holeScores;
            $element.addClass('panel panel-default mat-elevation-z6');
            ctrl.labels = [];
            ctrl.frontScores = holeScores.filter(function (holeScore) { return holeScore.holeNumber >= 1 && holeScore.holeNumber <= 9.1; });
            ctrl.backScores = holeScores.filter(function (holeScore) { return holeScore.holeNumber >= 10 && holeScore.holeNumber <= 18.1; });
            ctrl.totals = [holeScores.find(function (holeScore) { return holeScore.holeNumber == 18.2; })].filter(function (x) { return x != null });
            ctrl.labels.$parent = ctrl.frontScores.$parent = ctrl.backScores.$parent = ctrl.totals.$parent = ctrl.data;

            // Create Drag Scroll
            scrollbox = $element[0].querySelector('.scrollbox');
            scrollbox.addEventListener('mousedown', onMouseDown);
            scrollbox.addEventListener('scroll', onScroll);
        }
        function getCellClass(holeNumber) {
            return holeNumber == 9.1 ? 'cell-out' : holeNumber == 18.1 ? 'cell-in' : holeNumber == 18.2 ? 'cell-tot' : 'cell-hole cell-' + holeNumber;
        }
        function getFirClass(fir) {
            switch (fir) {
                case fairwayHitType.Hit: return 'fa fa-check'
                case fairwayHitType.MissedShort: return 'fa fa-arrow-down';
                case fairwayHitType.MissedLong: return 'fa fa-arrow-up';
                case fairwayHitType.MissedLeft: return 'fa fa-arrow-left';
                case fairwayHitType.MissedRight: return 'fa fa-arrow-right';
                case fairwayHitType.MissedUnspecified: return 'fa fa-times';
                default: return null;
            }
        }
        function hideScrollbar() {
            var scoresPanel = scrollbox.parentElement;
            scrollbox.style.overflowX = 'hidden';
            scoresPanel.style.height = scoresPanel.offsetHeight + 'px';
            scrollbox.style.overflowX = 'scroll';
        }
        function isBackVisible() {
            var data = ctrl.data;
            return data.holesPlayed === holesPlayed.EighteenHoles || data.holesPlayed === holesPlayed.BackNine;
        }
        function isEighteenHoles() {
            return ctrl.data.holesPlayed === holesPlayed.EighteenHoles;
        }
        function isFrontVisible() {
            var data = ctrl.data;
            return data.holesPlayed === holesPlayed.EighteenHoles || data.holesPlayed === holesPlayed.FrontNine;
        }
        
        // Dragging Events
        function preventGlobalMouseEvents() {
            document.body.style['pointer-events'] = 'none';
            document.documentElement.style.cursor = 'grabbing';
        }
        function restoreGlobalMouseEvents() {
            document.body.style['pointer-events'] = '';
            document.documentElement.style.cursor = '';
        }
        function onMouseDown(e) {
            preventGlobalMouseEvents();
            document.addEventListener('mouseup', onMouseUp, true);
            document.addEventListener('mousemove', onMouseMove, true);
            e.preventDefault();
            e.stopPropagation();
            downX = e.clientX;
        }
        function onMouseMove(e) {
            e.stopPropagation();
            scrollbox.scrollLeft = scrollbox.scrollLeft - event.clientX + downX;
            downX = event.clientX;
        }
        function onMouseUp(e) {
            restoreGlobalMouseEvents();
            document.removeEventListener('mouseup', onMouseUp, true);
            document.removeEventListener('mousemove', onMouseMove, true);
            e.stopPropagation();
        }
        function onScroll(e) {
            var 
                padding = 40,
                isScrollStart = ctrl.isScrollStart,
                isScrollEnd = ctrl.isScrollEnd,
                newIsScrollStart = scrollbox.scrollLeft <= padding,
                newIsScrollEnd = scrollbox.scrollLeft >= scrollbox.scrollWidth - scrollbox.clientWidth - padding;

            console.log(scrollbox.scrollLeft, scrollbox.scrollWidth - scrollbox.clientWidth);
            if (isScrollStart !== newIsScrollStart || isScrollEnd !== newIsScrollEnd) {
                $scope.$apply(function () {
                    ctrl.isScrollStart = newIsScrollStart;
                    ctrl.isScrollEnd = newIsScrollEnd;
                });
            }
        }

        function showFront() {
            scrollbox.scrollLeft = 0;
        }
        function showBack() {
            scrollbox.scrollLeft = scrollbox.scrollWidth - scrollbox.clientWidth;
        }
    }
})();